const liveApiUrl = "https://api.elumiamedstore.com/api/madikaBazzar";
const localApiUrl = "http://localhost:5000/api/madikaBazzar";
const configuredApiUrl = process.env.REACT_APP_API_URL?.trim();

export const API_URL = {
  api: (configuredApiUrl ||
    (process.env.NODE_ENV === "development" ? localApiUrl : liveApiUrl)
  ).replace(/\/+$/, ""),
};
